var _circle, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCollection1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 21,
    cy: 21,
    r: 21,
    fill: "url(#pattern0)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_44_269",
    transform: "scale(0.00260417)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_44_269",
    width: 384,
    height: 384,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAYAAAAGABAMAAABW6aiMAAAAMFBMVEX1v5MPGjjFz8vr7egzSVB8l5Y1hbpPncTD8/Q018A0g7dOm8HA7/A8HVHyvZF6JXtgVylGAAABtElEQVR4Ae3bEWwEQRTH4XMbt7qt27mdW93W7dzqVre61a1uddvKo5dMpplM9mVz389uTv4fTnb3JkmSJEmSJEmSJEmSJEmSJEmSJEmSJKmX2mQAAAAAAAAAAAAAANcFtOgt2qL7PyuHAAAAAAAAAAAAAAAsG/6IiiAAAAAAAAAAAAAAAAXDc7UQAAAAAIAVAQAAAAAAtE6PQclzIQAAAAAAAAAAAAAAQIvunbZBFwYAAAAAAAAAAAAAANQGAAAAUBYAAAAAAADAGPYe7alnp49odH4dAAAAAAAAAAAAAABAiwAAAAAAAAAAAAAAAPKQ51TrIQAAAAAAAAAAAAAA6yGf0R4NhpdDAAAAAAAAAAAAAADWQ76i1wEAAAAAAAAAAAAAAGTId1TwYXQxAAAAAAAAAAAAAACg/EUnAAAAAAAAAAAAAIDTh/9EW9Qm+40AAADmAwAAAAAAAACoGn5E+XeL9lT+/zYfAAAAAAAAAAAAAMDJw49UvtAcqd75aRAAAAAAAAAAAAAAgHUXmEGjwRm+HgIAAAAAAAAAAAAAcNaDjNkLzARkDQAAAAAAAAAAAAAA4A8AMCyGcU958gAAAABJRU5ErkJggg=="
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCollection1);
export default __webpack_public_path__ + "static/media/collection1.12a93879dd1f9373d7eae3ac8ccdd309.svg";
export { ForwardRef as ReactComponent };